declare global {
  interface Window {
    __CONFIG__?: {
      apiBaseUrl?: string;
      googleClientId?: string;
    };
  }
}

const cfg = window.__CONFIG__ ?? {};

export const API_BASE_URL = cfg.apiBaseUrl ?? '';
export const GOOGLE_CLIENT_ID = cfg.googleClientId ?? '';
